import { render, staticRenderFns } from "./selectStandardId.vue?vue&type=template&id=07fdc4f9"
import script from "./selectStandardId.vue?vue&type=script&lang=js"
export * from "./selectStandardId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports